module.exports = __webpack_public_path__ + "static/ss6.7593db43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss6.png
// module id = 1169
// module chunks = 112875127094159